import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";

import { Headersub } from "../GenericComponent/HeaderSub/headersub";
import { SearchBar } from "./SearchBar";
import { AddTaiSanBtn } from "./AddTaiSan";
import { AddTaiSanDeskTopBtn } from "./AddTaiSanDesktop.js";
import { TableDanhSachTaiSan } from "./TableDanhSachTaiSan";
import LayoutV2 from "containers/LayoutV2";
import UserApi from "service/userApi";

export const DanhSachTaiSan = () => {
  const [dsQuyen, setDsQuyen] = useState(null);
  const initDataSearch = {
    dateFrom: "01/01/2001",
    dateTo: "01/01/4000",
    code: "",
    customerName: "",
    address: "",
    noteTaiSan: "",
    status: "5",
    debt: "-1",
    userName: "",
    pageIndex: 1,
    pageSize: 20,
    ThoiGian: "",
  };
  useEffect(() => {
    //alert(1);
    document.title = "Danh sách tài sản | Phần mềm quản lý cầm đồ Morman";
    UserApi.getAllQuyen()
      .then((res) => {
        setDsQuyen(
          res.status === 200 && Array.isArray(res.data)
            ? res.data.map((item) => (item.ModuleCode || "").toLowerCase())
            : [],
        );
      })
      .catch(() => setDsQuyen([]));
  }, []);

  const [dataSearch, setDataSearch] = useState(initDataSearch);

  const ListDanhSachTaiSan = (dataSearch) => {
    //return getListNhanVay(dataSearch);
  };
  if (dsQuyen === null) return <LayoutV2></LayoutV2>;

  if (!dsQuyen.includes("danhsachtaisan")) {
    return (
      <LayoutV2>
        <h2 className="text-danger">
          <div className="custom-table-row">
            <div
              className="custom-table-cell text-center red"
              style={{ width: "100%" }}
            >
              Bạn không có quyền truy cập trang này!
            </div>
          </div>
        </h2>
      </LayoutV2>
    );
  }

  return (
    <LayoutV2>
      <div id="form-repeater">
        <div className="sticky-moman-bh">
          <div className="col-12">
            <div className="camdo-home">
              <div className="breadcrumb-new hidden-mobile-main">
                <div className="row">
                  <div className="col-sm-12 col-md-12 title-cd">
                    <div className="media-home align-center-home">
                      <div class="row header">
                        <img
                          className="icon-bred-home"
                          src="/app-assets/images/logo-quan-ly-tai-san.png"
                          alt=""
                        />
                        <h1 className="text-info-home">
                          Danh sách tài sản
                        </h1>
                      </div>
                    </div>
                    <AddTaiSanDeskTopBtn />
                  </div>
                </div>
              </div>
              <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                <div className="card-body card-body-v2">
                  <SearchBar />
                </div>
              </div>
            </div>
            <AddTaiSanBtn />
          </div>
        </div>
        <TableDanhSachTaiSan dsQuyen={dsQuyen} />
      </div>
    </LayoutV2>
  );
};
